<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $t('messages.group_tag_medallions_page_title'),
                        href: meta.links.index,
                    },
                    {
                        name: group.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex gap-4 flex-wrap">
            <div>
                <div>
                    {{ $tc('messages.subject', 2) }}
                </div>
                <div class="flex flex-wrap gap-x-2">
                    <AppButton
                        element="InertiaLink"
                        :href="subject.url"
                        v-for="subject in options.subjects"
                        :key="subject.id"
                        class="flex gap-x-2"
                    >
                        {{ subject.text }}

                        <IconCircleCheckFilled
                            class="h-5 w-5 text-indigo-600"
                            v-if="filters.subject_id == subject.id"
                        />
                    </AppButton>
                </div>
            </div>

            <div>
                <div>
                    {{ $tc('messages.grade_levels', 1) }}
                </div>
                <NavLinks :links="meta.nav_links.grade_levels" />
            </div>
        </div>

        <div class="flex flex-wrap -space-x-1 relative z-0 mt-3" v-if="filters.subject_id">
            <InertiaLink
                v-for="student in options.students"
                :key="student.id"
                :title="student.text"
                :href="student.url"
            >
                <img
                    :src="student.avatar_or_default"
                    class="relative z-30 inline-block h-8 w-8 rounded-full ring-2 ring-white"
                    :class="{ 'opacity-50': filters.student_id != student.id }"
                    alt=""
                />
            </InertiaLink>
        </div>

        <div v-if="content_blocks.length" class="mt-5 sm:col-span-12">
            <AppWell class="mt-5">
                <div class="md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-6 mt-3">
                    <div v-for="block in content_blocks" :key="block.id">
                        <AppCard>
                            <div class="p-1">
                                <div class="font-bold">
                                    {{ block.name }}
                                </div>
                                <div class="pl-3 divide-y divide-gray-300">
                                    <div class="mt-3" v-for="section in block.sections" :key="section.name">
                                        <div class="mt-3">
                                            {{ section.name }}
                                        </div>
                                        <div class="pl-3">
                                            <div
                                                v-for="tag in section.tags"
                                                :key="tag.id"
                                                class="mt-1 flex items-center gap-x-2"
                                            >
                                                <div>
                                                    <MedallionLevelsInfo :levels-info="tag.levels_info" />
                                                </div>
                                                <AppButton
                                                    element="button"
                                                    type="button"
                                                    v-if="tag.url === null"
                                                    :title="tag.description"
                                                    disabled
                                                >
                                                    {{ tag.name }}
                                                </AppButton>
                                                <AppButton
                                                    v-else
                                                    element="InertiaLink"
                                                    :href="tag.url"
                                                    :title="tag.description"
                                                    :desired-action="tag.desired_action"
                                                >
                                                    {{ tag.name }}
                                                </AppButton>
                                                <div>
                                                    <TagHelpSlideOver :tag="tag" />
                                                </div>
                                                <div v-if="tag.expected_level">
                                                    <Tippy>
                                                        <button>
                                                            <BadgePill color="indigo">
                                                                {{ tag.expected_level }}
                                                            </BadgePill>
                                                        </button>
                                                        <template #content>
                                                            <span>
                                                                {{
                                                                    $t('messages.expected_level_X_indicator', {
                                                                        level: tag.expected_level,
                                                                    })
                                                                }}
                                                            </span>
                                                        </template>
                                                    </Tippy>
                                                </div>
                                                <IconSpeedboat class="text-indigo-500 h-5 w-5" v-if="tag.in_race" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </AppCard>
                    </div>
                </div>
            </AppWell>
        </div>
        <EmptyState v-else-if="!!filters.difficulty" picture />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SmartBreadcrumbs from '@/components/SmartBreadcrumbs.vue';
import { IconCircleCheckFilled, IconSpeedboat } from '@tabler/icons-vue';
import AppButton from '@/components/AppButton.vue';
import EmptyState from '../../../../components/EmptyState.vue';
import AppWell from '../../../../Shared/AppWell.vue';
import AppCard from '../../../../Shared/AppCard.vue';
import MedallionLevelsInfo from '../../../../components/MedallionLevelsInfo.vue';
import TagHelpSlideOver from '../../../Student/Activity/Practice/partials/TagHelpSlideOver.vue';
import BadgePill from '../../../../components/BadgePill.vue';
import { Tippy } from 'vue-tippy';
import NavLinks from '../../../../components/NavLinks.vue';

export default {
    components: {
        NavLinks,
        Tippy,
        BadgePill,
        TagHelpSlideOver,
        MedallionLevelsInfo,
        AppCard,
        AppWell,
        EmptyState,
        IconSpeedboat,
        AppButton,
        IconCircleCheckFilled,
        SmartBreadcrumbs,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'filters', 'group', 'options', 'content_blocks'],
};
</script>
